import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["href", "alt"]
const _hoisted_2 = { class: "BabillardListItem_Title" }
const _hoisted_3 = { class: "BabillardListItem_Subtitle" }

import { ref, onMounted, onBeforeUnmount, computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'BabillardListItemComponent',
  props: {
  img: {
    type: String,
    required: true
  },
  title: {
    type: String,
    required: true
  },
  content: {
    type: String,
    required: true
  },
  url: {
    type: String,
    required: true
  }
},
  setup(__props) {

const props = __props;

const isMobile = ref(false);

const setPosition = () => {
  isMobile.value = window.innerWidth < 768;
};

const goToUrl = (url: string) => {
  window.open(url, "_blank");
};

const truncatedContent = computed(() => {
  if (props.content.length > 300) {
    return props.content.trim().substring(0, 300) + '...';
  } else {
    return props.content.trim();
  }
});

onMounted(() => {
  setPosition();
  window.addEventListener('resize', setPosition);
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', setPosition);
});

return (_ctx: any,_cache: any) => {
  const _component_b_card_img = _resolveComponent("b-card-img")!
  const _component_b_card_text = _resolveComponent("b-card-text")!
  const _component_b_card_body = _resolveComponent("b-card-body")!
  const _component_b_card = _resolveComponent("b-card")!

  return (_openBlock(), _createBlock(_component_b_card, {
    "no-body": "",
    class: "mb-3 BabillardListItem"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_b_card_img, {
        src: __props.img,
        alt: __props.title,
        class: "BabillardListItem_Image",
        top: isMobile.value,
        left: !isMobile.value,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (goToUrl(__props.url)))
      }, null, 8, ["src", "alt", "top", "left"]),
      _createVNode(_component_b_card_body, null, {
        default: _withCtx(() => [
          _createVNode(_component_b_card_text, {
            class: "BabillardListItem_Text",
            "text-tag": "div"
          }, {
            default: _withCtx(() => [
              _createElementVNode("a", {
                href: __props.url,
                alt: __props.title,
                target: "blank",
                class: "BabillardListItem_Link"
              }, [
                _createElementVNode("span", _hoisted_2, _toDisplayString(__props.title), 1)
              ], 8, _hoisted_1),
              _createElementVNode("p", _hoisted_3, _toDisplayString(truncatedContent.value), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})